import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/feedback" className="footer-link">Report a Bug / Feedback</Link>
        </div>
        <p className="disclaimer-text">
          lolcalculator.gg isn't endorsed by Riot Games and doesn't reflect the views or opinions of Riot Games 
          or anyone officially involved in producing or managing Riot Games properties. Riot Games, and all 
          associated properties are trademarks or registered trademarks of Riot Games, Inc.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
